import React from 'react';
import { tailChase } from 'ldrs';
import colors from '../theme/colors.js';
import { useTheme } from '@mui/system';
tailChase.register();

/**
 * We have three types of loaders:
 * Full = The entire site is covered with the loader
 * Container = Only the container the loader is in is covered by the loader
 * Modal = Loader for the modals, it covers the entire page but with no backdrop
 * @param isContainer
 * @param isModal
 * @param whitelabel
 * @returns {JSX.Element}
 * @constructor
 */
const Loader = ({
  isContainer = false,
  isModal = false
}) => {
  const styles = {
    backdrop: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      zIndex: 20000,
      position: 'fixed',
      left: 0,
      top: 0,
      overflow: 'auto',
      backgroundColor: isModal ? null : 'rgba(255, 255, 255, 0.5)'
    },
    gif: {
      position: 'absolute',
      top: '50vh',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      height: 200,
      width: 'auto',
      zIndex: 30000
    },
    spinner: {
      position: 'absolute',
      top: '50vh',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 30000
    },
    containerBackdrop: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      zIndex: 20000,
      position: 'absolute',
      left: 0,
      top: 0,
      overflow: 'auto',
      backgroundColor: isModal ? null : 'rgba(255, 255, 255, 0.5)'
    },
    containerGif: {
      minHeight: 200,
      height: 'auto',
      width: 'auto',
      zIndex: 30000
    },
    containerSpinner: {
      position: 'absolute',
      zIndex: 30000
    }
  };
  const theme = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    style: isContainer ? styles.containerBackdrop : styles.backdrop
  }, /*#__PURE__*/React.createElement("div", {
    style: isContainer ? styles.containerSpinner : styles.spinner
  }, /*#__PURE__*/React.createElement("l-tail-chase", {
    size: "80",
    speed: "1.5",
    color: theme?.palette?.primary?.main || colors.skyBlue
  })));
};
export default Loader;